export default __webpack_public_path__ + "static/guestlisticon-d223864bf2a8a68cc1a6eba7abcf232f.png";